import {
    DesligarChamadaServices,
    EfetuarDiscagemServices,
    LoginAgenteServices,
    LogoutAgenteServices,
} from "../../../Services/Geral/Telefonia/TelefoniaServices";
import { Controller } from "../../Controller";

export async function EfetuarDiscagemController(
    telefoneContato: string,
    idCaso: number
) {
    return Controller(EfetuarDiscagemServices(telefoneContato, idCaso));
}

export async function LogoutAgenteController() {
    return Controller(LogoutAgenteServices());
}

export async function LoginAgenteController() {
    return Controller(LoginAgenteServices());
}

export async function DesligarChamadaController(idCaso: number) {
    return Controller(DesligarChamadaServices(idCaso));
}
